/**
 * Extract the user's Nostr private key (hex) from their nsec login.
 * Returns null if the user is not logged in with an nsec.
 * Cashero needs the raw private key for NIP-44 encryption/decryption
 * in wallet↔mint operations.
 */

import { nip19 } from 'nostr-tools';
import { bytesToHex } from '@noble/hashes/utils';
import { useNostrLogin } from '@nostrify/react/login';

export function useUserPrivkeyHex(): string | null {
  const { logins } = useNostrLogin();
  const nsecLogin = logins.find((l) => l.type === 'nsec');
  if (!nsecLogin) return null;

  try {
    const nsec = (nsecLogin as any).data?.nsec;
    if (!nsec) return null;
    const decoded = nip19.decode(nsec);
    if (decoded.type !== 'nsec') return null;
    return bytesToHex(decoded.data as Uint8Array);
  } catch {
    return null;
  }
}
